import { useCallback, useState } from 'react';
import { Button } from '@/components/Button';
import { FlexColPageContainer } from '@/components/FlexColPageContainer';
import { saveDraftImage } from '@/features/nativeBridge/lib/imageBridge';
import { navigate } from '@/features/routing';
import { getDebugRing } from '@/lib/devUtils';
import { useMoodRecordDraft } from '@/lib/moodUtils/MoodRecordDraftContext';
import { useUserData } from '@/lib/userData/UserDataProvider';
import { clx } from '@/lib/utils';
import { ContinueButton } from '../ContinueButton';
import { AddNote } from './AddNote';
import { AddPhoto } from './AddPhoto';
import { createBase64FromPhotoFile } from './utils';

export const PhotoAndNoteForm = () => {
  const { moodRecordDraft, updateMoodRecordDraft, photoFile, setPhotoFile } = useMoodRecordDraft();
  const [noteText, setNoteText] = useState(moodRecordDraft?.note || '');
  const [userData] = useUserData();
  const uid = userData.firebaseUserId;

  const handleSubmit = useCallback(async () => {
    if (!moodRecordDraft) return;
    const moodDate = moodRecordDraft.moodDate;

    let imagePath: string | undefined = moodRecordDraft.imagePath;
    if (photoFile) {
      const base64 = await createBase64FromPhotoFile(photoFile);
      imagePath = await saveDraftImage(uid, moodDate, base64);
    }

    const success = await updateMoodRecordDraft({
      note: noteText,
      imagePath,
      imageContentType:
        moodRecordDraft.imageContentType || photoFile?.type?.split('/')?.[1] || undefined,
    });

    if (success) {
      navigate('/mood-log-entry/step5');
    } else {
      // TODO: Handle this error. Could add toast notification here.
    }
  }, [moodRecordDraft, noteText, photoFile, uid, updateMoodRecordDraft]);

  if (!moodRecordDraft?.mood) {
    return (
      <FlexColPageContainer className="justify-start text-center">
        <div className="mx-auto my-3 w-10/12 text-center">
          <h1 className="text-2xl text-black">Please select your mood first.</h1>
          <Button onClick={() => history.go(-3)} variant="buttonPrimary">
            Go to Step 1
          </Button>
        </div>
      </FlexColPageContainer>
    );
  }

  return (
    <>
      <div className={clx('mt-7 flex size-full flex-col', getDebugRing('blue'))}>
        <AddPhoto photoFile={photoFile} setPhotoFile={setPhotoFile} />
        <AddNote noteText={noteText} setNoteText={setNoteText} />
      </div>

      {/* Continue button */}
      <ContinueButton
        className={clx('w-full transition-all duration-100', getDebugRing('red'))}
        onClick={handleSubmit}
      />
    </>
  );
};
